import { Component, inject, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  listRow,
  MenuOption,
} from '@standard-angular-utilities/shared-components';
import { LogService } from 'BaseServices/log-service';
import { MainService } from 'BaseServices/main-service';
import {
  ClientSummaryDTO,
  FeatureOptionSummaryDTO,
  FeatureDetailDTO,
  FeatureSummaryDTO,
  PlantSummaryDTO,
} from 'projects/Assets/src/assets-base/dataTypes';
import { FeatureDialogComponent } from 'projects/Assets/src/assets-base/Dialogs/feature-dialog/feature-dialog.component';
import { forkJoin } from 'rxjs';
import {
  BaseListPageComponent,
  multiSelectFilterList,
} from 'src/app/BasePages/base-list-page/base-list-page.component';

@Component({
  selector: 'app-feature-view',
  imports: [BaseListPageComponent],
  templateUrl: './feature-view.component.html',
  styleUrl: './feature-view.component.css',
})
export class FeatureViewComponent {
  extraBurgerMenuOptions: MenuOption[] = [];
  headerList: string[] = ['Feature', 'Antal', 'Anlæg', 'Kunde'];
  @ViewChild('baseListPage')
  baseListPage!: BaseListPageComponent<FeatureSummaryDTO>;
  readonly dialog = inject(MatDialog);
  logHeaderList: string[];

  multiSelectFilterLists: multiSelectFilterList[] = [];
  clients: ClientSummaryDTO[] = [];
  plants: PlantSummaryDTO[] = [];
  features: FeatureSummaryDTO[] = [];
  featureOptions: FeatureOptionSummaryDTO[] = [];
  constructor(
    private mainService: MainService,
    private logService: LogService
  ) {
    this.logHeaderList = this.logService.getLogHeaders('aftale'); // Lige nu ser den ud til at være lavet til specifikt timelog så vi skal tage en beslutning med det her
  }
  ngOnInit(): void {}
  ngAfterViewInit(): void {
    this.updateListFeatures();
  }
  updateMultiSelectFilterLists() {
    const list: multiSelectFilterList[] = [];

    const featureOptionFilter: multiSelectFilterList = {
      Items: this.featureOptions.map((f) => ({ id: f.id, name: f.name })),
      selectedItemsIds: this.featureOptions.map((f) => f.id),
      placeHolderText: 'Vælg Feature',
      selectedValueChange: function (event: number[]) {
        this.selectedItemsIds = event;
      },
      filterFunction: function (feature: FeatureSummaryDTO) {
        const selectedNames = this.selectedItemsIds
          .map((id: number) => featureOptionFilter.Items.find((x: any) => x.id === id)?.name)
          .filter(Boolean);

        return feature != null && selectedNames.includes(feature.featureOptionName);
      },
      HideWithHeaderIndex: 0,
    };
    list.push(featureOptionFilter);

    const plantFilter: multiSelectFilterList = {
      Items: this.plants.map((p) => ({ id: p.id, name: p.plantName })),
      selectedItemsIds: this.plants.map((p) => p.id),
      placeHolderText: 'Vælg Anlæg',
      selectedValueChange: function (event: number[]) {
        this.selectedItemsIds = event;
      },
      filterFunction: function (feature: FeatureSummaryDTO) {
        const selectedNames = this.selectedItemsIds
          .map((id: number) => plantFilter.Items.find((x: any) => x.id === id)?.name)
          .filter(Boolean);

        return feature?.plantName != null && selectedNames.includes(feature.plantName);
      },
      HideWithHeaderIndex: 2,
    };
    list.push(plantFilter);

    const clientFilter: multiSelectFilterList = {
      Items: this.clients.map((c) => ({ id: c.id, name: c.name })),
      selectedItemsIds: this.clients.map((c) => c.id),
      placeHolderText: 'Vælg Kunde',
      selectedValueChange: function (event: number[]) {
        this.selectedItemsIds = event;
      },
      filterFunction: function (feature: FeatureSummaryDTO) {
        const selectedNames = this.selectedItemsIds
          .map((id: number) => clientFilter.Items.find((x: any) => x.id === id)?.name)
          .filter(Boolean);

        return feature != null && selectedNames.includes(feature.clientName);
      },
      HideWithHeaderIndex: 3,
    };
    list.push(clientFilter);

    this.multiSelectFilterLists = list;
  }

  featureClicked = (feature?: FeatureSummaryDTO) => {

    if (feature?.id == null) {
      const featureRequest: FeatureDetailDTO = {
        id: 0,
        featureOptionId: null as any,
        amount: 0,
        clientId: null as any,
        plantId: null as any
      };

      const dialogRef = this.dialog.open(FeatureDialogComponent, {
        data: { data: [featureRequest] },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result == true) {
          this.updateListFeatures();
        }
      });

      return;

    }
    else {
      this.mainService.get<FeatureDetailDTO>('feature', feature.id).subscribe((result) => {
        var featureRequest: FeatureDetailDTO;
        featureRequest = {
          id: feature.id,
          featureOptionId: result.featureOptionId,
          amount: feature.amount,
          clientId: result.clientId,
          plantId: result.plantId
        };

        let dialogRef = this.dialog.open(FeatureDialogComponent, {
          data: { data: [featureRequest] },
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result == true) {
            this.updateListFeatures();
          }
        });
      });
    }


  }

  switchDataInList() {
    // TODO få til at ligne den i courseParticipant componetn
  }

  updateListFeatures() {
    forkJoin({
      clients: this.mainService.getAll<ClientSummaryDTO>('client'),
      plants: this.mainService.getAll<PlantSummaryDTO>('plant'),
      features: this.mainService.getAll<FeatureSummaryDTO>('feature'),
      featureOptions: this.mainService.getAll<FeatureOptionSummaryDTO>('featureOption'),
    }).subscribe(({ clients, plants, features, featureOptions }) => {
      this.clients = clients;
      this.plants = plants;
      this.features = features;
      this.featureOptions = featureOptions;
      this.updateMultiSelectFilterLists();

      let listData: listRow<FeatureSummaryDTO>[] = [];
      features.forEach((feature) => {
        listData.push({
          object: feature,
          id: feature.id,
          data: [
            feature.featureOptionName,
            feature.amount.toString(),
            feature.plantName ?? "",
            feature.clientName
          ],
        });
      });
      this.baseListPage.UpdateListData(listData);
    });
  }
}
